import { render, staticRenderFns } from "./price-ups-downs-futures.vue?vue&type=template&id=46cad9b1&scoped=true&"
import script from "./price-ups-downs-futures.vue?vue&type=script&lang=js&"
export * from "./price-ups-downs-futures.vue?vue&type=script&lang=js&"
import style0 from "./price-ups-downs-futures.vue?vue&type=style&index=0&id=46cad9b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cad9b1",
  null
  
)

export default component.exports